import React from "react";
import { confirmAlert } from "react-confirm-alert";
import { handleImageError } from "../../../Functionalities/Functions";

function RestaurantGallery({ data, ManageRestaurantImage, showMessage }) {
  return (
    <div className="profile-interest mb-5">
      <h5 className="text-primary d-inline">Gallery</h5>
      <div className="row mt-4 sp4" id="lightgallery">
        {data.images && data.images.length > 0 ? (
          data.images.map((image) => {
            return (
              <React.Fragment key={image.id}>
                <a
                  style={{
                    borderRadius: 5,
                    overflow: "hidden",
                  }}
                  href={image.image}
                  data-exthumbimage={image.image}
                  data-src={image.image}
                  className="mb-1 col-lg-4 col-xl-4 col-sm-4 col-6"
                >
                  <img
                    src={image.image}
                    style={{
                      height: 120,
                      borderRadius: 10,
                    }}
                    alt="foodoor"
                    className="img-fluid"
                    onError={handleImageError}
                  />
                </a>

                {data.images.length > 1 && (
                  <li role="presentation">
                    <i
                      className="fa fa-trash-o text-danger"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.preventDefault();
                        confirmAlert({
                          customUI: ({ onClose }) => {
                            return (
                              <div
                                className="custom-ui"
                                style={{
                                  borderRadius: 8,
                                  border: "solid",
                                  padding: 70,
                                  borderWidth: 0.5,
                                }}
                              >
                                <h1>Are you sure?</h1>
                                <p>You want to delete ?</p>
                                <button
                                  onClick={onClose}
                                  className="btn btn-primary"
                                  style={{
                                    marginRight: 10,
                                  }}
                                >
                                  Cancel
                                </button>
                                <button
                                  onClick={() => {
                                    let res = ManageRestaurantImage(
                                      e,
                                      [image.id],
                                      "patch",
                                      ""
                                    );
                                    res
                                      .then((res) => {
                                        if (res.data.Status === true) {
                                          showMessage(
                                            "Delete success",
                                            "success",
                                            "Success!",
                                            "top",
                                            "top-right"
                                          );
                                          window.location.reload();
                                        } else {
                                          showMessage(
                                            res.data.Error,
                                            "danger",
                                            "Failed!",
                                            "top",
                                            "top-right"
                                          );
                                        }
                                      })
                                      .catch((err) => {
                                        showMessage(
                                          "Error deleting image",
                                          "danger",
                                          "Error!",
                                          "top",
                                          "top-right"
                                        );
                                      });
                                  }}
                                  className="btn btn-primary"
                                >
                                  Delete
                                </button>
                              </div>
                            );
                          },
                        });
                      }}
                    ></i>
                  </li>
                )}
              </React.Fragment>
            );
          })
        ) : (
          <a
            href="https://static.thenounproject.com/png/2879926-200.png"
            data-exthumbimage="https://static.thenounproject.com/png/2879926-200.png"
            data-src="https://static.thenounproject.com/png/2879926-200.png"
            className="mb-1 col-lg-4 col-xl-4 col-sm-4 col-6"
          >
            <img
              src="https://static.thenounproject.com/png/2879926-200.png"
              alt="No images available"
              className="img-fluid"
            />
          </a>
        )}
      </div>
    </div>
  );
}

export default RestaurantGallery;
